import {Component, Input} from '@angular/core';
import {translate} from '@ngneat/transloco';

@Component({
  selector: 'app-ksuite-info-block',
  templateUrl: './ksuite-info-block.component.html',
  styleUrls: ['./ksuite-info-block.component.scss']
})
export class KsuiteInfoBlockComponent {
  @Input() lightDisplay: boolean = false;
  @Input() gradientBorder: boolean = false;

  get subtitleWording(): string {
    if (this.lightDisplay) {
      return translate('Une suite d\'applications et de services pour faciliter le travail en collaboration');
    }
    return translate('Une suite d\'applications et services* collaboratifs');
  }
}
